import React, { useState, useEffect } from 'react'
import './header-consulting.scss'

const HeaderConsulting = (props) => {
    const {mobile, banners} = props;
    const [pageLoad, setpageLoad] = useState(false)

    useEffect(() => {
        setpageLoad(true)
    }, [])

    return (
        <div className="f-header-consulting">
            <div className="f-header-consulting-wrapper">
                <img
                    alt={(mobile ? banners.bannerMobile.description : banners.bannerDesktop.description)}
                    src={pageLoad ? (mobile ? banners.bannerMobile : banners.bannerDesktop).file.url : (mobile ? banners.bannerMobile : banners.bannerDesktop).fixed.base64} 
                    className="f-header-consulting-banner-img"
                />
                
                { !mobile && <div 
                className={`f-header-consulting-texts ${process.env.LOCALE === 'es-PE' ? 'pe-variant' : ''}`}>
                    <h1 className="f-main-title f-h1">{banners.nombre}</h1>
                    <h2 className="f-main-subtitle f-h2">{banners.descripcionImagen}</h2>
                    <p className="f-main-description f-p">{banners.descripcionImagen2}</p>
                </div>}
            </div>
        </div>
    )
}

export default HeaderConsulting
